import React from "react";
import './footer.scss';

class Footer extends React.Component{
    render(){
        return(
            <footer>
                <p>Tejas Nashikkar</p>
                <img src="images/footer-img.png" alt="footer-img" />
            </footer>
        );
    }
}

export default Footer;